module.exports = __webpack_public_path__ + "img/9.37170e1e.jpg";